module.exports = __webpack_public_path__ + "img/_close_navy.42e310b0.svg";